export default __webpack_public_path__ + "static/media/pt.f6eae4ea.png";